import { environment } from "src/environments/environment";
import { LoggerConfig } from "@board/cloud-library/components/services";
import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";

export interface ApplicationConfigs {
  loggerConfig: LoggerConfig;
  appInsightsKey?: string;
  appInsightsConnectionString?: string;
}

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const applicationConfigs: ApplicationConfigs = {
  loggerConfig: environment.loggerConfig,
  appInsightsKey: environment.appInsightsKey,
  appInsightsConnectionString: environment.appInsightsConnectionString
};

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.clientId,
    authority: environment.authority,
    redirectUri: "/", // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
    knownAuthorities: ["account.board.com", "boardb2c.b2clogin.com"],
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: true
    }
  }
};

export const loginRequest = {
  scopes: [environment.apiScope]
};

export const roles = {
  User: "User",
  SuperUser: "SuperUser"
};
